import VestMarketsLogo from '@/assets/branding/vest-markets-logo';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

interface Props {
  content?: React.ReactNode;
  description: React.ReactNode;
  footer?: React.ReactNode;
  title: string;
  wide?: boolean;
}

export default function CenteredCard({
  content,
  description,
  footer,
  title,
  wide,
}: Props) {
  return (
    <div className="flex h-full items-center justify-center px-3 py-6">
      <Card
        className="relative mx-auto w-full overflow-hidden border shadow-2xl shadow-black/10"
        style={{ maxWidth: wide ? 640 : 448 }}
      >
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-primary/0 via-primary to-primary/0" />
        <CardHeader className="items-center px-5 pb-5 text-center sm:px-8">
          <VestMarketsLogo className="mb-5 h-9 w-auto" />
          <CardTitle className="text-2xl font-semibold sm:text-3xl">
            {title}
          </CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        {content && (
          <CardContent className="px-5 sm:px-8">{content}</CardContent>
        )}
        {footer && <CardFooter className="px-5 sm:px-8">{footer}</CardFooter>}
      </Card>
    </div>
  );
}
